module.exports = __webpack_public_path__ + "static/media/1001660TL.78107192.jpg";